import * as React from "react";
import i18n from "i18n";
import { observer } from "mobx-react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Input,
  InputAdornment,
  DialogActions,
  IconButton,
  Button,
  withStyles,
} from "@material-ui/core";
import { Visibility, VisibilityOff, Close } from "@material-ui/icons";

import { ProfileStore } from "modules/profile/ProfileStore";
import { LoginStore } from "modules/login/LoginStore";
import { ProfileService } from "modules/profile/ProfileService";

const styles = (theme) => ({
  textFieldRoot: {
    width: "100%",
    marginBottom: "35px",
  },
  textFieldInput: {
    color: "#212121",
    fontFamily: "Roboto",
    fontSize: "18px",
    fontWeight: 400,
    display: "block",
  },
});

type IProps = {
  classes: any;
};

@observer
class ModalLinkCredencial extends React.Component<IProps> {
  state = {
    email: LoginStore.userAuth != undefined ? LoginStore.userAuth.email : "",
    password: "",
    showPassword: false,
    disabledActions: false,
  };

  handleClose = () => (ProfileStore.ModalLinkCredencial = false);
  handleConfirm = () => {
    const { email, password } = this.state;
    this.setState({ disabledActions: true }, () =>
      ProfileService.linkCredencial(
        LoginStore.userAuth != undefined ? LoginStore.userAuth.uid : "",
        email,
        password,
        this.linkCredencialCallback
      )
    );
  };
  linkCredencialCallback = (response) => {
    if (response === true)
      ProfileStore.message = i18n.firebaseFunctions.linkWithCredential.success;
    else
      ProfileStore.message = i18n.firebaseFunctions.linkWithCredential[
        response.code
      ]
        ? i18n.firebaseFunctions.linkWithCredential[response.code]
        : i18n.firebaseFunctions.linkWithCredential.error;
    ProfileStore.openSnackbar = true;
    ProfileStore.password = true;
    this.setState({ disabledActions: false });
    this.handleClose();
  };

  handleChange = (key) => (e) => (this.state[key] = e.target.value);

  handleClickShowPassword = () =>
    this.setState((prevState: any) => ({
      showPassword: !prevState.showPassword,
    }));

  render() {
    const { classes } = this.props,
      { disabledActions } = this.state,
      textField = {
        root: classes.textFieldRoot,
        input: classes.textFieldInput,
      };
    return (
      <Dialog
        open={ProfileStore.ModalLinkCredencial}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
      >
        <DialogTitle>
          {i18n.profile.modalLinkCredencial.title}
          <IconButton
            onClick={this.handleClose}
            className={classes.closeIcon}
            style={{ position: "absolute" }}
            disabled={disabledActions}
          >
            <Close fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <TextField
            classes={textField}
            label={i18n.profile.email}
            onChange={this.handleChange("email")}
            defaultValue={
              LoginStore.userAuth != undefined ? LoginStore.userAuth.email : ""
            }
            disabled={disabledActions}
          />
          <Input
            type={this.state.showPassword ? "text" : "password"}
            onChange={this.handleChange("password")}
            autoComplete="off"
            style={{ width: "100%" }}
            disabled={disabledActions}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="Toggle password visibility"
                  onClick={this.handleClickShowPassword}
                >
                  {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={this.handleClose}
            disabled={disabledActions}
            color="secondary"
          >
            {i18n.cancel}
          </Button>
          <Button
            onClick={this.handleConfirm}
            disabled={disabledActions}
            color="primary"
            autoFocus
          >
            {i18n.save}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default withStyles(styles)(ModalLinkCredencial);



// WEBPACK FOOTER //
// ./src/modules/profile/components/layouts/ModalLinkCredencial.tsx